import {SET_ERRORS} from "../storeconstants";

export default {

    [SET_ERRORS](state, errors) {
        state.errors = errors;
    },
}